import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./index.css";
import WebsiteRoute from "./website/index.js"; // Import WebsiteRoute
import AdminRoute from "./admin/index.js"; // Import WebsiteRoute

const root = ReactDOM.createRoot(document.getElementById("root"));

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<WebsiteRoute />} />
          <Route path="/admin/*" element={<AdminRoute />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
